import type { FunctionComponent } from "react";
import type { StringIndexedObject } from "@kanda-libs/ks-component-ts";
import Profile from "components/shared/Profile";
import { getJobStatusLabel } from "./helpers";
import useCompanyJobStats from "./useCompanyJobStats";

export interface CompanyJobStatsProps {}

const CompanyJobStats: FunctionComponent<CompanyJobStatsProps> = function () {
  const { total, ...statuses } = useCompanyJobStats();

  return (
    <Profile.Section title="Company job stats">
      <Profile.Property label="Jobs" value={total} />
      <>
        {Object.keys(statuses).map((status) => (
          <Profile.Property
            key={status}
            label={getJobStatusLabel(status)}
            value={(statuses as StringIndexedObject)[status]}
          />
        ))}
      </>
    </Profile.Section>
  );
};

export default CompanyJobStats;
